import { useSelector } from 'react-redux';
import { getIsUserInternal } from 'state/selectors/common/user';

export function useIsInternalUser(): boolean {
  return useSelector(getIsUserInternal);
}
